import * as React from "react";
import styled from "styled-components";
import { Button, Table, AutoComplete } from "antd";
import { useState, useReducer } from "react";
import { useAuth } from "@/component/Auth";
import {getAllBroadcastNumberRules} from "@/api/virtualRule";
import {
  AnyType,
  BoolType,
  ConfefenctType,
  ConferenceInterface,
} from "@/types";
import { SettingOutlined, NotificationOutlined } from "@ant-design/icons";
import { Tooltip, Modal, Input } from "antd";
import NumericInput from "../../../component/MyInput/MyInput";
// import Rtm from "@/hooks/use-rtm";
import useRtm from "@/hooks/use-rtm";
import { storage } from "@/util";
import {
  LOGININFOSTORE,
  METTINGPAGE_SAVED_MEETING_INFO,
  NORMALSETTINGKEY,
  LOGINTOKEN
} from "@/config/const";
import { conference, users } from "@/api";
import { time } from "@/util";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Message } from "@/qrtc_web_rtm/protoo-client/Message";
import { message } from "antd";
import isElectron from "is-electron";
const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 12px 12px 0;
  margin-bottom: 10px;
  .header {
    font-size: 16px;
    font-weight: 400;
    color: #999;
    height: 30px;
    position: relative;
    width: 85%;
    .btn {
      position: absolute;
      right: 10px;
      top: 3px;
    }
  }
  .main {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    /* padding: 5px 10px; */
    border: 1px solid #eee;
    border-radius: 3px;
  }
  .footer {
    height: 50px;
    display: flex;
    flex-direction: line;
    justify-content: center;
    align-items: center;
    width: 100%;
    .cancel {
      margin-left: 70px;
    }
  }
`;
// localStorage
const Contacts: React.FunctionComponent = () => {
  const history = useHistory();
  const rtm = useRtm({}, (closedByServer)=>{
    console.log("[Login] closedByServer", closedByServer);
    //关闭rtm
    rtm.logout();
    //退出登录
    storage.remove(LOGININFOSTORE);
    storage.remove(LOGINTOKEN);
    if (isElectron()) {
      alert(`Нэвтрэх хуудас руу чиглүүлж байна`);
      history.replace("/");
    } else {
      window.location.href = "/";
    }
    alert("Нэвтрэх оролдлого олон удаа хийгдлээ");
  });
  const [tableData, setTableData] = React.useState<AnyType[]>([]);
  const [selectedIds, setSelectedIds] = React.useState<string[]>([]);
  const [open, setOpen] = useState(false);
  // const [rules, setRules] = useState<AnyType[]>([]);
  const [mvalue, setMvalue] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const auth = useAuth();
  let rules = JSON.parse(localStorage.getItem("prepareToCallList") || "[]");
  const { loggedIn, loginfo, updateLogInfo } = auth;
  const presenceEve = (evt: any) => {
    const {
      action = "",
      channelName = "",
      channelType = "",
      publisher = "",
    } = evt;
    //
    if (
      action.toLowerCase() === "remote_join" &&
      channelName.toLowerCase() === "notification" &&
      channelType.toLowerCase() === "message"
    ) {
      //
      const act = tableData.find((x) => x.id === publisher);
      if (!act) {
        setTableData([...tableData, { id: publisher }]);
      }
    }
  };

  const messageEve = (evt: any) => {
    //
    console.log(evt);
  };

   
  React.useEffect(() => {
    if (rtm) {
      rtm.addEventListener("presence", presenceEve);
      rtm.addEventListener("message", messageEve);
    } else {
      console.log("rtm is null");
    }
    return () => {
      if (rtm) {
        rtm.removeEventListener("presence", presenceEve);
        rtm.removeEventListener("message", messageEve);
      }
    };
  }, [rtm]);

  ///////////////////////////////////////////////////
  const tableColumns = [
    { title: "账户", dataIndex: "id", width: "60%" },
    {
      title: "操作",
      width: "20%",
      render: (_: any, record: any) => (
        <div className="fac">
          <Button
            size="small"
            type="primary"
            className="w50"
            onClick={() => inviteMeeting(record)}
          >
            呼叫
          </Button>
        </div>
      ),
    },
  ];

  const inviteMeeting = async (rec: any) => {
     
     
    const loginfData = storage.get(LOGININFOSTORE);
    const messagebox = {
      action: "call",
      room: loginfData.conferenceNo,
      data: {
        virtualNum: rec.virtualNum,
        video: { code: "H264", resolution: "1024X768" },
        audio: { sampleRate: "44100", channels: 2 },
      },
    };
    console.log("inviteMeeting:::"+JSON.stringify(messagebox))
     
    const ret = await rtm.publishToPeer(
      rec.id,
      // message
      JSON.stringify(messagebox)
    );
     // 开始计时
    const timer = setTimeout(() => {
      
      message.error("连接超时");
     
    }, 10000); // 10秒后计时结束

    // clearTimeout(timer);
  };


  const callList = async () => {
    console.log("发起会议，开始呼叫，准备入会");
    const loginfData = storage.get(LOGININFOSTORE);
    const message = {
      action: "call",
      participants: selectedRowKeys,
      room: loginfData.conferenceNo,
      data: {
        // virtualNum: rec.virtualNum,
        video: { code: "H264", resolution: "1024X768" },
        audio: { sampleRate: "44100", channels: 2 },
      },
    };

    const ret = await rtm.publish(
      /**rec.id**/ "notification",
      // message
      JSON.stringify(message)
    );

    createNewMeeting();
  };

  ///////////////////////////////////////////////////

  const [selectedRowKeys, setSelectedRowKeys] = React.useState<Array<string>>(
    []
  );

  const RowSelectObje = React.useMemo(
    () => ({
      selectedRowKeys,
      onChange: (keys: any[]) => {
        setSelectedRowKeys(keys);
      },
    }),
    [selectedRowKeys]
  );

  /////// 呼叫操作

  const createNewMeeting = async () => {
    const loginfo = storage.get(LOGININFOSTORE);
    const ret: any = await conference.conferenceCreate({
      title: `${loginfo.username || loginfo.realName}的会议`,
      beginTime: time.format(moment()),
      endTime: time.format(moment()),
      allowEarlyEntry: BoolType.yes,
      muteJoinMeeting: BoolType.yes,
      playTips: BoolType.no,
      allowSelfUnmute: BoolType.yes,
      passwordEnable: BoolType.no,
      useSelfConference: 1,
      type: ConfefenctType.immediate,
      conferenceNo: loginfo.conferenceNo,
    });
    joinMeeting(ret.conferenceNo);
  };

  const joinMeeting = async (conferenceNo: string) => {
     
    const loginfo = storage.get(LOGININFOSTORE);
    const ret = await conference.conferenceJoin(
      {
        userName: loginfo.username,
        conferenceNo,
      },
      {
        "X-Conference-No": conferenceNo, //	${conferenceNo}	会议号
        "X-Device": "1", //	8
      }
    );
    const con = ret.conference as ConferenceInterface;
    con["X-Channel-Token"] = ret["X-Channel-Token"];
    con["X-Conference-Token"] = ret["X-Conference-Token"];
      // 此处赋予主持人角色
    con.roleCode = ret.roleCode;
    con.roleName = ret.roleName;

    if(con.roleCode === 20){
      con.roleName = ret.roleName;
      //  con.roleName = "主持人";
      con.currHostUserId = con.userId
    }
    con.roomid = ret.roomid;
   

    con.userId = ret.userid;
    console.log("joinMeeting result:::", JSON.stringify(con)  );
    goMeeting(con);
  };

  const goMeeting = async (conf: ConferenceInterface) => {
    const loginfo = storage.get(LOGININFOSTORE);
    const settings = (storage.get(NORMALSETTINGKEY) || {}) as AnyType;
    storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
    const url = `/meeting/${conf.roomId}?username=${
      loginfo.realName
    }&audio=${!!settings.mic}&video=${!!settings.video}&speaker=${!!settings.audio}`;
    history.push(url);
  };

  ////////////////////////////////////////////////////////////////////////////////
  /// 下面一套数据，先从接口取
  const [datasource, setdatasourrce] = React.useState<AnyType[]>([]);
  const getApiUserList = async () => {
      await users
      .userlists({ pageNum: 1, PageSize: 1000 })
      .then((response) => {
        
        //请修改选中代码，增补根据从ausers检索出的虚拟号码与输入的虚拟号码进行对比，相同的返回真
        // @ts-ignore
        const ausers = (response?.users ?? []).map((x: AnyType) => ({
          ...x,
          id: x.userId,
        }));
        setdatasourrce(ausers);
      }).catch((error) => {
        alert("Интернетээ шалгана уу")
        console.log(error);
      });
  };
  // 发送虚拟号邀请入会的json

  const tableColumns1 = [
    { title: "Account", dataIndex: "phone", width: "25%" },
    { title: "Username", dataIndex: "nickname", width: "25%" },
    // { title: "电话", dataIndex: "phone", width: "25%" },
    { title: "Verify number", dataIndex: "virtualNum", width: "25%" },
    {
      title: "Ажиллуулах",
      width: "20%",
      render: (_: any, record: any) => (
        <div className="fac">
          <Button
            size="small"
            type="primary"
            className="w50"
            onClick={() =>
               inviteMeeting(record)
              }
          >
            Залгах
          </Button>
        </div>
      ),
    },
  ];

  React.useEffect(() => {
    getApiUserList();
  }, []);
  const showModal = () => {
    setOpen(true);
  };
  // React.useEffect(() => {
  //   selectedRowKeys.length > 0 && callList();
  //   // 在这里，你可以执行你想在 setSelectedRowKeys 更新后执行的操作
  // }, [selectedRowKeys]);
  const searchByVirtualCodeRule = async (e: any) => {
     
    const ret = await users.userlists({ pageNum: 1, PageSize: 1000, phone: e });
    const ausers = (ret?.users ?? []).map((x: AnyType) => ({
      ...x,
      id: x.userId,
    }));

    const target = mvalue;
    //请修改选中的代码，检索输入字符里面有没有 #，？，* ； 其中#和？号的含义是只允许输入1个数字， *含义是不限量输入数字，根据这个规则，检索出符合条件的虚拟号码

    const targetPattern = target
      .replace(/#/g, "\\d")
      .replace(/\?/g, "\\d")
      .replace(/\*/g, "\\d*");

    const regex = new RegExp(`^${targetPattern}$`);

    const results =await ausers.filter(
      (item: any) =>
        //根据规则检索出符合条件的虚拟号码，放入results数组中
        regex.test(item.virtualNum)
      //  item.virtualNum.includes(target)
    );
    const ids =await results.map((item: any) => item.id);
    console.log(ids);

    //
    setSelectedRowKeys((prevState) => [...prevState, ...ids]);
    //发现反选不及时，导致没勾上，因此被迫加此处理
    setTimeout(() => {
      setSelectedRowKeys((ids) => {
        // 在这里，prevState 是 setSelectedRowKeys 的当前状态
        // 你可以根据 prevState 计算新的状态
        const newState = ids;
        return newState;
      });
    }, 1000);
  
    if (ids.length === 0) {
      alert("Дугаар буруу байна");
    } else {
      // callList()
    }
  };
  const handleOk = (e: any) => {
    setConfirmLoading(true);
    // 这里添加你的确认操作代码
    ;
      
       getAllBroadcastNumberRules().then((res)=>{
           if(res && res.data && res.data.length > 0){
               
              localStorage.setItem("prepareToCallList",JSON.stringify(res.data));
              rules = JSON.parse(localStorage.getItem("prepareToCallList") || "[]");
              // @ts-ignore
              if (!rules.some((rule) => rule.number === mvalue)) {
                setConfirmLoading(false);
                const isMatch = datasource.some((user) => user.virtualNum === mvalue);
                if (!isMatch) {
                  alert("Дугаар буруу байна");
                  return;
                  // throw new Error("输入的虚拟号码在系统中不存在!");
                }
              }
              searchByVirtualCodeRule(e);
              setConfirmLoading(false);
              setOpen(false);
           } else {
              console.log("disc");
           }
         
       })
    
  };

  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <Container>
      <div className="header">
        <span>通讯录</span>
        {selectedRowKeys.length > 0 && (
          <Button
            className="btn"
            size="small"
            type="primary"
            onClick={callList}
          >
            发起会议
          </Button>
        )}
      </div>
      <div className="main">
        <Table
          columns={tableColumns1}
          dataSource={datasource}
          rowSelection={RowSelectObje}
          rowKey="id"
          size="small"
          pagination={false}
        />
      </div>
      <div className="footer">
        <Button
          type="primary"
          icon={<NotificationOutlined />}
          // loading={loadings[1]}
          onClick={() => {
             
            getAllBroadcastNumberRules().then((res)=>{
              showModal();
            })
           
          }}
        >
          呼叫！
        </Button>
        <Modal
          title="根据规则，呼叫符合条件的虚拟号码"
          visible={open}
          onOk={handleOk}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
        >
          <AutoComplete
            style={{ width: 120 }}
            // @ts-ignore
            dataSource={rules.map((rule) => rule.number)}
            value={mvalue}
            onChange={setMvalue}
          />
        </Modal>
        <Button
          type="primary"
          icon={<SettingOutlined />}
          className="cancel"
          onClick={() => {
            setSelectedRowKeys([]);
          }}
        >
          取消
        </Button>
      </div>
    </Container>
  );
};

export default Contacts;
